import {ReactElement} from 'react'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import messages from '../../../../../../../assets/messages'
import {formatNumber} from '../../../../../../../common/utils'
import Amount from '../../../../../../Common/Amount'
import {useStatistics} from '../../hooks/useStatistics'
import {AmountClassNames} from '../../types'
import {GridSection} from '../GridSection'
import {LoadingLayout} from '../LoadingLayout'
import {ErrorLayout} from '../ErrorLayout'

type TotalStatisticsPropsBase = {
  accountId: number
  amountClassNames: AmountClassNames
}

type TotalStatisticsProps = TotalStatisticsPropsBase & WithNamespaces

const Component = (props: TotalStatisticsProps): ReactElement => {
  const {lng, accountId, amountClassNames} = props

  const totalStatistics = useStatistics(accountId)

  if (totalStatistics.loading) return <LoadingLayout />
  if (totalStatistics.error || !totalStatistics.data) return <ErrorLayout scope='stats' />

  const {
    totalFollowers,
    activeFollowers,
    losingTrades,
    winningTrades,
    totalProfit,
    totalPerformanceFee,
    currency
  } = totalStatistics.data.statistics

  return (
    <GridSection
      title={<Trans {...messages.allTimePerformance} />}
      items={[
        {
          id: messages.totalFollowersCount.i18nKey,
          caption: <Trans {...messages.totalFollowersCount} />,
          value: formatNumber(lng, totalFollowers)
        },
        {
          id: messages.totalActiveFollowersCount.i18nKey,
          caption: <Trans {...messages.totalActiveFollowersCount} />,
          value: formatNumber(lng, activeFollowers)
        },
        {
          id: messages.totalLosingTradesCount.i18nKey,
          caption: <Trans {...messages.totalLosingTradesCount} />,
          value: formatNumber(lng, losingTrades)
        },
        {
          id: messages.totalWinningTradesCount.i18nKey,
          caption: <Trans {...messages.totalWinningTradesCount} />,
          value: formatNumber(lng, winningTrades)
        },
        {
          id: messages.totalCopiedPnl.i18nKey,
          caption: <Trans {...messages.totalCopiedPnl} />,
          value: <Amount value={totalProfit} currency={currency} locale='en-US' classes={amountClassNames} />
        },
        {
          id: messages.totalPerformanceFee.i18nKey,
          caption: <Trans {...messages.totalPerformanceFee} />,
          value: <Amount value={totalPerformanceFee} currency={currency} locale='en-US' classes={amountClassNames} />
        }
      ]}
    />
  )
}

export const TotalStatistics = withNamespaces()(Component)
